import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import SearchBox from "./SearchBox";
import { logout } from "../actions/userActions";

function Header() {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const dispatch = useDispatch();
  

  const logoutHandler = () => {
    dispatch(logout());
    // go to home page after logout
    window.location.href = "/";
    
  };

  return (
    <div className="hidden-print">
      <header>
        <Navbar bg="primary" variant="dark" expand="lg" collapseOnSelect >
          <Container>
            <LinkContainer to="/">
              <Navbar.Brand>
                <img
                  src={`https://${process.env.REACT_APP_LINODE_BUCKET}.${process.env.REACT_APP_LINODE_BUCKET_REGION}.linodeobjects.com/images/logos/main/main-logo.png`}
                  height={50}
                  alt="LSTA"
                  className="d-inline-block align-top logo"
                ></img>
              </Navbar.Brand>
            </LinkContainer>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            <Navbar.Collapse id="basic-navbar-nav">
              <div className="search">
                <SearchBox />
              </div>
              <Nav className="nav-links-container">
                <LinkContainer to="/cart">
                  <Nav.Link>
                    <i className="fas fa-shopping-cart"></i>Quote
                  </Nav.Link>
                </LinkContainer>

                {userInfo ? (
                  <NavDropdown title={userInfo.business_name} id="username">
                    <LinkContainer to="/profile">
                      <NavDropdown.Item>Saved Quotes</NavDropdown.Item>
                    </LinkContainer>

                    <NavDropdown.Item onClick={logoutHandler}>
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                ) : (
                  <LinkContainer to="/login">
                    <Nav.Link>
                      <i className="fas fa-user"></i>Login
                    </Nav.Link>
                  </LinkContainer>
                )}

                {userInfo && userInfo.isAdmin && (
                  <NavDropdown title="Admin" id="adminmenue">
                    <LinkContainer to="/admin/userlist">
                      <NavDropdown.Item>Users</NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to="/admin/productlist">
                      <NavDropdown.Item>Products</NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to="/admin/orderlist">
                      <NavDropdown.Item>Orders</NavDropdown.Item>
                    </LinkContainer>
                  </NavDropdown>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </div>
  );
}

export default Header;
